import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import NumberFormat from 'react-number-format';
import BaseInput from '../base';

const validate = val =>
  string()
    .required('Enter a loan amount')
    .matches(/^[1-9]\d*(((\d{3}){1})?(\.\d{0,2})?)$/, {
      message: 'Enter a valid loan amount'
    })
    .min(3, 'Loan cannot be less than 3 characters')
    .validate(val)
    .then(() => null)
    .catch(err => err.errors.join(', '));

const Input = inputProps => (
  <BaseInput
    name="amount"
    label="Full Loan Amount"
    type="number"
    autoComplete="off"
    transparent
    useLocalState={false}
    {...inputProps}
  />
);

const Amount = ({ onTouched, onChange, ...rest }) => (
  <NumberFormat
    thousandSeparator
    prefix="$"
    onValueChange={values =>
      onChange({ ...values, name: 'amount', type: 'number' }, validate)
    }
    {...rest}
    customInput={Input}
  />
);

Amount.propTypes = {
  onChange: PropTypes.func.isRequired,
  onTouched: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string
};

Amount.defaultProps = {
  value: '',
  error: ''
};

export default Amount;
